module.exports = __webpack_public_path__ + "static/img/kumo.eb72898.jpg";